import { useMemo, useState, useEffect, useCallback } from "react";
import {SetMetaData} from './../../helper/page-title';
import ValidationHelper from "../../helper/validation";
import {toggleBodyLoader} from './../../helper/custom-function';
import useInfiniteList from "../../hooks/infinite-list";
import InfiniteListWrapper from "../../components/wrapper/infinite-list";
import { error_api_call, post_api_call, get_api_call, get_pdf_api_call} from "../../actions/action-creators/common";
import { alertResponseMessage } from "../../actions/action-creators/response";
import {
        fieldCohortNew,
        fieldValuesCohortNew,
        fieldValidationCohortNew,
        //Students:Update
        fieldCohortEdit,
        fieldValuesCohortEdit,
        fieldValidationCohortEdit,
        //Editor:Update
        fieldCohortEditor,
        fieldValuesEditor,
        fieldValidationEditor,
        //Nomi
        fieldCohortNomination,
        fieldValuesNomination,
        fieldValidationNomination,
        //Award
        fieldCohortAward,
        fieldValuesAward,
        fieldValidationAward,
        //Filter
        filterTableData
    } from "../../data/formData/glosco/cohort";
import WrapTooltip from "../../components/wrapper/tooltip";
//Modal
import ModalMaster from "../../modal/master";
import ModalWrapper from "../../modal/wrapper";
import normalizeFilters from "../../helper/filter/normalize-filter";
import FilterFloatMaster from "../../components/form/filter/filter-float";
import {
  yesNoOpp
} from "../../data/formData/option";

const noticeWarningsMsgs = {
    cohort_new: ['Students cannot be edited once the Council has started.'],
    nomination: ['Nomination details cannot be edited once awards have been submitted for the Council.']
};

function GloscoCohortList(props) {
    SetMetaData("Manage Cohort", "", "");
    const [cohortFieldData, setCohortFieldData] = useState([]);
    const [cohortFieldValue, setCohortValueData] = useState({
                                                        cohort_new   : {...fieldValuesCohortNew},
                                                        nomination   : {...fieldValuesNomination},
                                                        award        : {...fieldValuesAward},
                                                        cohort_edit  : {...fieldValuesCohortEdit},
                                                        editor_update: {...fieldValuesEditor},
                                                    });
    const [activeEditForm, setActiveForm] = useState("");
    const [councilSessionNum, setCouncilSessionNum] = useState({});
    const [detailedCohortData, setDetailedCohortData] = useState("");
    // Modal Form Data
    const [modalTitle, setModalTitle] = useState({cohort_new : 'Cohort Creation',
                                                cohort_edit  : 'Update Students',
                                                nomination   : 'Nominations & Attendance',
                                                award        : 'Awards & Rating',
                                                editor_update: 'Update Editors',
                                                cohort_view  :  'Cohort Details'
                                            });
    const [filterData, setFilterData] = useState({});
    const [tmpFilterData, setTmpFilterData] = useState({});
    const [errorData, setErrorData] = useState({cohort_new   : [],
                                                nomination   : [],
                                                award        : [],
                                                cohort_edit  : [],
                                                editor_update: []
                                            });
    const [isProcess, setIsProcess] = useState({cohort_new   : false,
                                                nomination   : false,
                                                award        : false,
                                                cohort_edit  : false,
                                                editor_update: false,
                                                filter       : false
                                            });
    const [refreshKey, setRefreshKey] = useState(0);
    const [dropdownOpt, setDropdownOpt] = useState({program: [],
                                                    level: [],
                                                    student: [],
                                                    school: [],
                                                    branch: [],
                                                    editor: []
                                                });
    const [dropdownNomiAwardOpt, setDropdownNomiAwardOpt] = useState({chair: [],
                                                    challenger: [],
                                                    presenter: [],
                                                    mentor: [],
                                                    member: [],
                                                    absentee: []
                                                });
    //Modal
    const [modalToggle, setModalToggle] = useState({cohort_new   : false,
                                                    nomination   : false,
                                                    cohort_edit  : false,
                                                    award        : false,
                                                    editor_update: false,
                                                    cohort_view  : false
                                                });

    const normalizedFilter = useMemo(
    () =>
        normalizeFilters(filterData, {
            school_id: "id",
            level_id: "id",
            branch_id: "id",
            program_id: "id",
            is_completed: "id"
        }),
        [filterData]
    );

    const memoizedPayload = useMemo(() => ({
        fetch_type: "manage_cohort",
        filter: normalizedFilter
    }), [normalizedFilter]); // Only changes when filters change

    const handleSuccess = useCallback((data) => {
        // Get the most recent page added
        const lastPageData = data.pages[data.pages.length - 1];
        
        if (lastPageData && Array.isArray(lastPageData.data)) {
            // Use functional state update to ensure we always have the latest 'councilSessionNum'
            setCouncilSessionNum(prevSessionData => {
                const updatedData = { ...prevSessionData };
                
                lastPageData.data.forEach(cohort_data => {
                    updatedData[cohort_data.id] = cohort_data.current_session_number;
                });
                
                return updatedData;
            });
        }
    }, []); // Empty dependency array keeps this function static

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteList({
        queryKey: ["manage_cohort", refreshKey],
        apiCall: payload => post_api_call("cohorts", payload),
        limit: 100,
        // extraPayload: {
        //     fetch_type: "manage_cohort",
        //     filter: normalizedFilter
        // },
        extraPayload: memoizedPayload,
        onSuccess: handleSuccess, 
        onError: (err) => {
            console.error("Cohort Fetch Error:", err);
            // Add your toast notification here
        }
    });

    // const masterTableData = data?.pages.flatMap(page => page.data) ?? [];
    const masterTableData = Array.isArray(data?.pages)
                            ? data.pages.flatMap(page => Array.isArray(page?.data) ? page.data : [])
                            : [];
    // const masterTableData = [1, 2, 3, 4, 5];
    // const masterTableData = masterTableData.map(r => r.id);
    useEffect(() => {
        //Initial API Data
        // fetchStudentList();
        fetchSelectList('cohort_creation_dropdown', 'dropdown-options/cohort-creation?is_glosco=1');
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    const getSelectedUserIds = (nomination) => {
        const fields = [
            nomination.chair_id,
            nomination.mentor1_id,
            nomination.mentor2_id,
            nomination.mentor3_id,
            nomination.mentor4_id,
            nomination.presenter1_id,
            nomination.presenter2_id,
            nomination.presenter3_id,
            nomination.presenter4_id
        ];

        // Collect single select ids
        const singleIds = fields
            .filter(Boolean)
            .map(item => item.user_id);

        // Multi select fields
        const multiIds = [
            ...(nomination.challenger_ids || []),
            ...(nomination.absentee_ids || [])
        ].map(item => item.user_id);

        return [...singleIds, ...multiIds];
    };
    //Remove selected role from previous selected field
    const roleLabels = {
        chair_id: "Chair",
        mentor1_id: "Mentor 1",
        mentor2_id: "Mentor 2",
        mentor3_id: "Mentor 3",
        mentor4_id: "Mentor 4",
        presenter1_id: "Presenter 1",
        presenter2_id: "Presenter 2",
        presenter3_id: "Presenter 3",
        presenter4_id: "Presenter 4",
        challenger_ids: "Challenger",
        absentee_ids: "Absentee"
    };

    const clearUserFromAllRoles = (nomination, userId, currentField) => {

        let updated = { ...nomination };
        let removedFrom = null;

        // Single fields
        Object.keys(roleLabels).forEach(field => {

            if (field === currentField) return;

            // Single select
            if (updated[field]?.user_id === userId) {
                removedFrom = roleLabels[field];
                updated[field] = "";
            }

            // Multi select
            if (Array.isArray(updated[field])) {
                const exists = updated[field].some(
                    item => item.user_id === userId
                );

                if (exists) {
                    removedFrom = roleLabels[field];
                    updated[field] = updated[field].filter(
                        item => item.user_id !== userId
                    );
                }
            }
        });

        return { updated, removedFrom };
    };
    //Nomi Validation
    const validateNomination = (nomination) => {
        const errors = [];

        for (let i = 3; i <= 4; i++) {

            const presenter = nomination[`presenter${i}_id`];
            const mentor = nomination[`mentor${i}_id`];

            if (presenter && !mentor) {
                errors.push(`Mentor ${i} is required if Presenter ${i} is selected`);
            }

            if (mentor && !presenter) {
                errors.push(`Presenter ${i} is required if Mentor ${i} is selected`);
            }

            if(i === 4){
                if (nomination[`presenter${i}_id`] && !nomination[`presenter${i-1}_id`]) {
                    errors.push(`Presenter ${i-1} must be selected before Presenter ${i}`);
                }

                if (nomination[`mentor${i}_id`] && !nomination[`mentor${i-1}_id`]) {
                    errors.push(`Mentor ${i-1} must be selected before Mentor ${i}`);
                }
            }
        }

        return errors;
    };
    //Get Data from APIs
    const fetchSelectList = async(type, url, form_data={}) => {
      try{
          const selectApiData = await get_api_call(url, {});
          var data = [];
          if(selectApiData.status === 200){
              data = selectApiData.data;
              switch (type) {
                  case 'cohort_creation_dropdown':
                    setDropdownOpt({...dropdownOpt,
                        program: data.ifspd_programs || [],
                        student: data.students || [],
                        level: data.glosco_years || [],
                        school: data.schools || [],
                        branch: data.branches || [],
                        editor: data.cohort_stakeholders || [],
                    });
                    break;
                  case 'cohort_students_dropdown':
                    setDropdownOpt({...dropdownOpt,
                        student: data.students || [],
                        editor: data.cohort_stakeholders || [],
                    });
                    break;
                  case 'cohort_updation_dropdown':
                    if(form_data.form_type === 'cohort_edit'){
                        setDropdownOpt({...dropdownOpt,
                            student: selectApiData.students || [],
                        });

                        setCohortValueData({...cohortFieldValue,
                                        cohort_edit: {...fieldValuesCohortEdit,
                                                student_ids: selectApiData.allocated_students || [],
                                                cohort_master_id: form_data.cohort_master_id
                                            }});

                    }else if(form_data.form_type === 'editor_update'){
                        setDropdownOpt({...dropdownOpt,
                            editor: selectApiData.editors || [],
                        });

                        setCohortValueData({...cohortFieldValue,
                                        editor_update: {...fieldValuesEditor,
                                                editor_ids: selectApiData.allocated_editors || [],
                                                cohort_master_id: form_data.cohort_master_id
                                            }});
                    }

                    toggleBodyLoader('remove');
                    break;
                    
                  default: 
              }
          }
          return {
              data
          };
      }catch(error){
        toggleBodyLoader('remove');
        error_api_call({error: `admin|screens|glosco|manage-cohort|fetchSelectList|${error}`});
        return {data: []};
      }
    }
    // Update Input
    const updateInput = (form_type, state_var_type, input_type, field, value, field_type="", form_field="", index=0) => {
      try{
        console.log(form_type, input_type, field, value)
          if(form_type !== "filter" && errorData[form_type].length){
            setErrorData({...errorData, [form_type]: []});
          }

          if(input_type === 'input'
              || input_type === 'textarea'
          ){
              value = value.trimStart();

              if(field === 'chair_rating' && value){
                if(value > 0 && value < 11 ){
                  value = value.replace(/[^0-9]/g, '');
                }else{
                  return false;
                }
              }
          }

          var updatedFormDetails = state_var_type === 'array' 
                            ? [] 
                            : state_var_type === 'object'
                                ? {}
                                : '';

          if(field_type === 'array'){
              const fieldData = {...cohortFieldValue[form_type]};
              fieldData[form_field][index][field] = value;
              updatedFormDetails = {...fieldData};
          }else{
            updatedFormDetails = {...cohortFieldValue[form_type]};
            updatedFormDetails[field] = value;
          }

          switch (form_type) {
                case 'cohort_new':
                    if(field === "school_id"
                        || field === "branch_id"
                    ){
                        updatedFormDetails.student_ids = '';
                        updatedFormDetails.editor_ids = '';
                    }

                    setCohortValueData({...cohortFieldValue, cohort_new: updatedFormDetails});

                    if(updatedFormDetails.school_id?.id
                        && updatedFormDetails.branch_id?.id
                        && (props.userRoleIds.includes(2)
                            || props.userRoleIds.includes(7)
                        )
                        && (field === "school_id"
                            || field === "branch_id"
                        )
                    ){
                        setDropdownOpt({...dropdownOpt,
                            student: [],
                            editor: [],
                        });

                        fetchSelectList('cohort_students_dropdown', `dropdown-options/students,cohort_stakeholders?school_id=${updatedFormDetails.school_id.id}&branch_id=${updatedFormDetails.branch_id.id}`);
                    }
                    break;
                case 'nomination':
                    if(field === "member_ids"){
                        return;
                    }
                    const selectedUserIds = getSelectedUserIds(updatedFormDetails);
                    const uniqueUserIds = [...new Set(selectedUserIds)];
                    const updatedMembers = dropdownNomiAwardOpt.member.filter(
                                                member => !uniqueUserIds.includes(member.user_id)
                                            );

                    updatedFormDetails.member_ids = updatedMembers;
                                            console.log(value , 'valuevaluevaluevaluevalue')
                    if(value){
                        let removedFrom = null;
                        // For single select
                        if (!Array.isArray(value)) {
                            const result = clearUserFromAllRoles(
                                updatedFormDetails,
                                value.user_id,
                                field
                            );

                            updatedFormDetails = result.updated;
                            removedFrom = result.removedFrom;

                            if (removedFrom) {
                                alertResponseMessage({alert_type: 4,
                                                    message: `${value.full_name} moved from ${removedFrom} to ${roleLabels[field]}`});
                            }
                        }

                        // For multi select
                        if (Array.isArray(value)) {
                            value.forEach(item => {
                                const result = clearUserFromAllRoles(
                                    updatedFormDetails,
                                    item.user_id,
                                    field
                                );

                                updatedFormDetails = result.updated;
                                removedFrom = result.removedFrom;

                                if (removedFrom) {
                                    alertResponseMessage({alert_type: 4,
                                                        message: `${item.full_name} moved from ${result.removedFrom} to ${roleLabels[field]}`});
                                }
                            });
                        }

                    }

                    break;

                case 'filter':
                    setTmpFilterData(updatedFormDetails);
                    break;
                default:
            }
          
            if(form_type !== "cohort_new"){
                setCohortValueData({...cohortFieldValue, [form_type]: updatedFormDetails});
            }
      }catch(error){
        console.error(error)
      }
    }
    //Toggle Modal
    const toggleModal = async(e, modal_type, toggleState, mod_data={}) => {
        try{
            if(toggleState){
                e.preventDefault();
            }
            if(toggleState){
                var legendTitle = 'Details';
                switch (modal_type) {
                    case 'cohort_new':
                        setCohortValueData({...cohortFieldValue, cohort_new: fieldValuesCohortNew});
                        setCohortFieldData([{form_type: modal_type, label: legendTitle, fields: [...fieldCohortNew]}]);
                        break;
                    case 'cohort_edit':
                        toggleBodyLoader('load');
                        setCohortValueData({...cohortFieldValue, cohort_edit: {...fieldValuesCohortEdit}});
                        setCohortFieldData([{form_type: modal_type, label: legendTitle, fields: [...fieldCohortEdit]}]);
                        setModalTitle({...modalTitle,
                                            cohort_edit: `Update Students: ${mod_data.title}`
                                        });
                        fetchSelectList('cohort_updation_dropdown', `cohort-roles-awards/dropdowns?cohort_master_id=${mod_data.cohort_master_id}&fetch_type=stu_member`, {form_type: 'cohort_edit', cohort_master_id:  mod_data.cohort_master_id});
                        break;
                    case 'editor_update':
                        toggleBodyLoader('load');
                        setCohortValueData({...cohortFieldValue, editor_update: {...fieldValuesEditor}});
                        setCohortFieldData([{form_type: modal_type, label: legendTitle, fields: [...fieldCohortEditor]}]);
                        setModalTitle({...modalTitle,
                                            cohort_edit: `Update Editor: ${mod_data.title}`
                                        });
                        fetchSelectList('cohort_updation_dropdown', `cohort-roles-awards/dropdowns?cohort_master_id=${mod_data.cohort_master_id}&fetch_type=editor`, {form_type: 'editor_update', cohort_master_id:  mod_data.cohort_master_id});
                        break;
                    case 'nomination':
                        toggleBodyLoader('load');
                        var cohortMasterIdNomi = mod_data.cohort_master_id;
                        var sessionNumberNomi = councilSessionNum[cohortMasterIdNomi];

                        setCohortValueData({...cohortFieldValue,
                                            nomination: {...fieldValuesNomination}});

                        const fetchStuRolesOpt = await fetchNomiAwardOptions('nomination',
                                                                        {cohort_master_id: cohortMasterIdNomi,
                                                                        session_number: sessionNumberNomi,
                                                                        fetch_type: 'nomination'
                                                                        });

                        if(fetchStuRolesOpt.status === 200){
                            setCohortFieldData([{form_type: modal_type, label: `Nomination ${legendTitle}`, fields: [...fieldCohortNomination]}]);
                            setModalTitle({...modalTitle,
                                            nomination: `Nominations & Attendance: ${mod_data.title}- Council ${sessionNumberNomi}`
                                        });
                        }else{
                            return;
                        }
                    
                        break;
                    case 'award':
                        toggleBodyLoader('load');
                        var cohortMasterId = mod_data.cohort_master_id;
                        var sessionNumber = councilSessionNum[cohortMasterId];

                        setCohortValueData({...cohortFieldValue,
                                            award: {...fieldValuesAward}});

                        const fetchStuAwardOpt = await fetchNomiAwardOptions('award',
                                                                        {cohort_master_id: cohortMasterId,
                                                                        session_number: sessionNumber,
                                                                        fetch_type: 'award'});

                        if(fetchStuAwardOpt.status === 200){
                            setCohortFieldData([{form_type: modal_type, label: `Award & Rating ${legendTitle}`, fields: [...fieldCohortAward]}]);
                            setModalTitle({...modalTitle,
                                            award: `Awards & Chair Rating: ${mod_data.title}- Council ${sessionNumber}`
                                        });
                        }else{
                            return;
                        }

                        break;
                    case 'cohort_view':
                        setDetailedCohortData('');
                        setModalTitle({...modalTitle,
                                            cohort_view: `Cohort - ${mod_data.title}`
                                        });
                        await fetchViewDownloadDetails(e, 'cohort_view', {fetch_type: 'view', cohort_master_id: mod_data.cohort_master_id});
                        break;
                    default: 
                        break;
                }
                setErrorData({...errorData, [modal_type]: []});
                
                if(modal_type !== 'cohort_view'){
                    setActiveForm(modal_type);
                }
            }

            setModalToggle({...modalToggle, [modal_type]: toggleState});

            if(modal_type === 'cohort_new'
                && (props.userRoleIds.includes(2)
                    || props.userRoleIds.includes(7)
                )
            ){
                setDropdownOpt({...dropdownOpt,
                        student: [],
                        editor: [],
                    });
            }

            if((modal_type === 'cohort_new') && dropdownOpt.program.length === 0){
                fetchSelectList('cohort_creation_dropdown', 'dropdown-options/cohort-creation?is_glosco=1');
            }
            
        }catch(error){
            console.log(error)
        }
    }
    //Get Nomination-Award dropdown Data
    const fetchNomiAwardOptions = async(api_type, payload) => {
        try{
            
            if(api_type === 'nomination'
                || api_type === 'award'
            ){
                setDropdownNomiAwardOpt({...dropdownNomiAwardOpt,
                                        chair       : [],
                                        challenger  : [],
                                        presenter   : [],
                                        mentor      : [],
                                        member      : [],
                                        absentee    : []
                                    });

                const fetchStuOpt = await post_api_call('cohort-roles-awards/dropdowns', payload);

                if(fetchStuOpt.status === 200){
                    const cohortMasterId = payload.cohort_master_id;
                    const sessionNumber = payload.session_number;

                    setDropdownNomiAwardOpt({...dropdownNomiAwardOpt,
                        chair       : fetchStuOpt.chair || [],
                        challenger  : fetchStuOpt.challenger || [],
                        presenter   : fetchStuOpt.presenter || [],
                        mentor      : fetchStuOpt.mentor || [],
                        member      : fetchStuOpt.member || [],
                        absentee    : fetchStuOpt.absentee || []
                    });

                    if(api_type === 'nomination'){
                        if(fetchStuOpt.alloted_roles){
                            setCohortValueData({...cohortFieldValue,
                                        nomination: {...fieldValuesNomination,
                                                    // ...fetchStuOpt.alloted_roles,
                                                    chair_id: fetchStuOpt.alloted_roles?.chair,
                                                    challenger_ids: fetchStuOpt.alloted_roles?.challenger,
                                                    absentee_ids: fetchStuOpt.alloted_roles?.absentee,
                                                    member_ids: fetchStuOpt.alloted_roles?.member,

                                                    presenter1_id: fetchStuOpt.alloted_roles?.presenter_1,
                                                    presenter2_id: fetchStuOpt.alloted_roles?.presenter_2,
                                                    presenter3_id: fetchStuOpt.alloted_roles?.presenter_3,
                                                    presenter4_id: fetchStuOpt.alloted_roles?.presenter_4,

                                                    mentor1_id: fetchStuOpt.alloted_roles?.mentor_1,
                                                    mentor2_id: fetchStuOpt.alloted_roles?.mentor_2,
                                                    mentor3_id: fetchStuOpt.alloted_roles?.mentor_3,
                                                    mentor4_id: fetchStuOpt.alloted_roles?.mentor_4,

                                                    cohort_master_id: cohortMasterId,
                                                    session_number: sessionNumber
                                                }});
                        }else{
                            setCohortValueData({...cohortFieldValue,
                                        nomination: {...fieldValuesNomination,
                                                    cohort_master_id: cohortMasterId,
                                                    session_number: sessionNumber,
                                                    member_ids: fetchStuOpt.member || []
                                                }});
                        }
                    }else{
                        setCohortValueData({...cohortFieldValue,
                                        award: {...fieldValuesAward,
                                                    cohort_master_id: cohortMasterId,
                                                    session_number: sessionNumber
                                                }});
                    }

                    toggleBodyLoader('remove');
                }else{
                    alertResponseMessage({alert_type: 2, message: "Error Loading Details! Try after some times"});
                    toggleBodyLoader('remove');
                    return;
                }

                return fetchStuOpt;
            }
        }catch(error){
            console.error(error);
            alertResponseMessage({alert_type: 2, message: "Error Loading Details! Try after some times"});
            toggleBodyLoader('remove');
            error_api_call({error: `admin|screens|glosco|manage-cohort|fetchNomiAwardOptions|${error}`});
            return {status: 500};
        }
    }
    //Submit Details
    const submitForm = async(e, form_type='') => {
        try{
            e.preventDefault();
            setErrorData({...errorData, [form_type]: []});
            setIsProcess({...isProcess, [form_type]: true});
            var errorDetails = [];
            var apiFormData = {};
            //Validation
            var validation = [];
            // var inputData = {};
            var validationFields = {};
            switch (form_type) {
                case 'cohort_new':
                    apiFormData = {...cohortFieldValue.cohort_new};
                    validationFields = fieldValidationCohortNew;
                    if(props.userRoleIds.some(role => [2, 7].includes(role))){
                        validationFields.school_id = 'required||School';
                        validationFields.branch_id = 'required||Branch';
                    }
                    break;
                case 'nomination':
                    apiFormData = {...cohortFieldValue.nomination};
                    validationFields = fieldValidationNomination;
                    break;
                case 'award':
                    apiFormData = {...cohortFieldValue.award};
                    validationFields = fieldValidationAward;
                    break;
                case 'editor_update':
                    apiFormData = {...cohortFieldValue.editor_update};
                    validationFields = fieldValidationEditor;
                    break;
                case 'cohort_edit':
                    apiFormData = {...cohortFieldValue.cohort_edit};
                    console.log(apiFormData , 'apiFormDataapiFormDataapiFormDataapiFormData')
                    validationFields = fieldValidationCohortEdit;
                    break;
                default:
            }
            validation = ValidationHelper.validation(apiFormData, validationFields).error;
            if(validation.length){
                errorDetails = validation;
            }else{
                if(form_type === 'cohort_new'){
                    const studentIds = [...new Set(apiFormData.student_ids.map(s => s.id))];
                    if(studentIds.length < 15){
                        errorDetails = ["Atleast 15 students required to form a Cohort"];
                    }
                }else if(form_type === 'nomination'){
                    var errorDetailsCha = [];

                    if(apiFormData.challenger_ids.length < 2 || apiFormData.challenger_ids.length > 4){
                        errorDetailsCha = ["Challengers must be between 2-4"];
                    }

                    const errorDetailsNomi = validateNomination(apiFormData);

                    errorDetails = [...errorDetailsCha, ...errorDetailsNomi];
                }else if(form_type === 'cohort_edit'){
                    const studentUpIds = [...new Set(apiFormData.student_ids.map(s => s.id))];
                    if(studentUpIds.length < 15){
                        errorDetails = ["Atleast 15 students required to form a Cohort"];
                    }
                }
            }
          
            if(errorDetails.length > 0){
                setErrorData({...errorData, [form_type]: errorDetails});
                setIsProcess({...isProcess, [form_type]: false});
                // setBtnDisabled({...isBtnDisabled, [form_type]: true});
            }else{
                toggleBodyLoader('load');
                //Send Data to Server
                var api = '';
                var successMsg = 'Cohort Created Successfully';

                switch (form_type) {
                    case 'cohort_new':
                        const studentIds = [...new Set(apiFormData.student_ids.map(s => s.id))];
                        const editorIds = apiFormData.editor_ids
                                            ? [...new Set(apiFormData.editor_ids.map(s => s.id))]
                                            : [];

                        apiFormData = {
                            level_id: apiFormData.level_id.id,
                            program_id: apiFormData.program_id.id,
                            student_ids: studentIds,
                            editor_ids: editorIds,
                            school_id: apiFormData.school_id?.id || '',
                            branch_id: apiFormData.branch_id?.id || '',
                        };

                        api = 'glosco-cohort/create';
                        break;
                    case 'nomination':
                        const memberIds = apiFormData.member_ids
                                            ? [...new Set(apiFormData.member_ids.map(s => s.user_id))]
                                            : [];
                                            console.log(apiFormData, 'kkkkkkkkkk')
                        const absenteeIds = apiFormData.absentee_ids
                                            ? [...new Set(apiFormData.absentee_ids.map(s => s.user_id))]
                                            : [];

                        apiFormData = {
                            cohort_master_id: apiFormData.cohort_master_id,
                            session_number  : apiFormData.session_number,
                            chair_id        : apiFormData.chair_id.user_id,
                            challenger_ids  : [...new Set(apiFormData.challenger_ids.map(s => s.user_id))],
                            absentee_ids    : absenteeIds,
                            member_ids      : memberIds,
                            presenter1_id   : apiFormData.presenter1_id?.user_id,
                            mentor1_id      : apiFormData.mentor1_id?.user_id,
                            presenter2_id   : apiFormData.presenter2_id?.user_id,
                            mentor2_id      : apiFormData.mentor2_id?.user_id,
                            presenter3_id   : apiFormData.presenter3_id?.user_id || '',
                            mentor3_id      : apiFormData.mentor3_id?.user_id || '',
                            presenter4_id   : apiFormData.presenter4_id?.user_id || '',
                            mentor4_id      : apiFormData.mentor4_id?.user_id || '',
                        };

                        api = 'glosco-cohort/nomination-update';
                        successMsg = `${modalTitle['nomination']} Updated Successfully`;
                        break;
                    case 'award':
                        if (!window.confirm("Are you sure you want to update? The information will be locked for the current council and no changes will be allowed.")) {
                            toggleBodyLoader('remove');
                            setIsProcess({...isProcess, [form_type]: false});
                            return;
                        }
                        apiFormData = {
                            cohort_master_id   : apiFormData.cohort_master_id,
                            session_number     : apiFormData.session_number,
                            chair_rating       : apiFormData.chair_rating,
                            best_presenter_id  : apiFormData.best_presenter_id?.user_id,
                            best_mentor_id     : apiFormData.best_mentor_id?.user_id,
                            best_challenger_id : apiFormData.best_challenger_id?.user_id,
                            council_date       : apiFormData.council_date
                        };

                        api = 'glosco-cohort/award-update';
                        successMsg = `${modalTitle['award']} Updated Successfully`;
                        break;
                    case 'cohort_edit':
                        apiFormData = {
                            cohort_master_id: apiFormData.cohort_master_id,
                            student_ids: [...new Set(apiFormData.student_ids.map(s => s.id))]
                        };

                        api = 'glosco-cohort/update-students';
                        successMsg = `Students Updated Successfully`;
                        break;
                    case 'editor_update':
                        const editorUpdateIds = apiFormData.editor_ids
                                            ? [...new Set(apiFormData.editor_ids.map(s => s.id))]
                                            : [];

                        apiFormData = {
                            cohort_master_id: apiFormData.cohort_master_id,
                            editor_ids: editorUpdateIds
                        };

                        api = 'glosco-cohort/update-editors';
                        successMsg = `Editor Updated Successfully`;
                        break;
                    
                    default:
                }

                const updateApiRes = await post_api_call(`${api}`, apiFormData);
                if(updateApiRes.status === 200){
                    alertResponseMessage({alert_type: 1, message: successMsg});
                    // setBtnDisabled({...isBtnDisabled, [form_type]: true});
                    // setSessionFormData({...fieldValuesConf});
                    switch (form_type) {
                        case 'cohort_new':
                            setCohortValueData({...cohortFieldValue, cohort_new: fieldValuesCohortNew});
                            // Load New Data
                            setRefreshKey(prev => prev + 1); //RESET TABLE
                            break;
                        case 'nomination':
                            setCohortValueData({...cohortFieldValue, nomination: fieldValuesNomination});
                            // Load New Data
                            setRefreshKey(prev => prev + 1); //RESET TABLE
                            break;
                        case 'award':
                            setCohortValueData({...cohortFieldValue, award: fieldValuesAward});
                            // Load New Data
                            setRefreshKey(prev => prev + 1); //RESET TABLE
                            break;
                        default:
                    }

                    toggleModal('', form_type, false);
                }else{
                    if(typeof updateApiRes.message !== "undefined"){
                        setErrorData({...errorData, [form_type]: [updateApiRes.message]});
                    }
                }
                setIsProcess({...isProcess, [form_type]: false});
                toggleBodyLoader('remove');
            }
          
        }catch(error){
            console.error(error);
            setErrorData({...errorData, [form_type]: ['Something Went Wrong, Please Try After Some Time']});
            setIsProcess({...isProcess, [form_type]: false});
            toggleBodyLoader('remove');
            error_api_call({error: `admin|screens|glosco|manage-cohort|submitForm|${error}`});
        }
    }
    //Only Owner+Super Admin+Admin can edit
    const canUserEdit = (row) => {
        // Check if user is the creator
        const isOwner = row.is_owner === 1;
        
        // Check if user has administrative roles
        const isAdmin = props.userRoleIds.includes(2) || props.userRoleIds.includes(7);
        
        return isOwner || isAdmin;
    };
    //View-Download Cohort Details
    const fetchViewDownloadDetails = async(e, fetch_type, payload) => {
      try{
            toggleBodyLoader('load');

            switch (fetch_type) {
                case 'cohort_view':
                    const apiData = await get_api_call('glosco-cohort/view-download-details', payload);

                    setDetailedCohortData(apiData.status === 200 ? apiData.html_content : '');

                    break;
                case 'cohort_download':
                    e.preventDefault();
                    e.target.disabled = true;

                    const apiDownloadData = await get_pdf_api_call('glosco-cohort/view-download-details', payload);

                    if(apiDownloadData.status === 200){
                        const blob = new Blob([apiDownloadData.response.data]);
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = `Report-${payload.title}.pdf`;
                        document.body.appendChild(link);
                        link.click();
                        window.URL.revokeObjectURL(url);
                    }else{
                        alertResponseMessage({alert_type: 2, message: "Error downloading Report! Please try after some times."});
                    }

                    e.target.disabled = false;
                    break;
                default: 
            }
          
            toggleBodyLoader('remove');
          
        }catch(error){
            toggleBodyLoader('remove');
            e.target.disabled = false;
            error_api_call({error: `admin|screens|glosco|manage-cohort|fetchViewDownloadDetails|${error}`});
            return {data: []};
        }
    }

    return (
        <>
        <div className="row">

            <div className="col-lg-12">
                <div className="card p-2 mb-2">
                    {/* Filter by: */}
                    <FilterFloatMaster
                        title="Filter Cohort"
                        formType="filter"
                        data={tmpFilterData}
                        _isProcess={{...isProcess}}
                        _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(form_type, variable_type, input_type, field, value)}
                        _formData={[{label: "Filter Cohort:", display_type: 'col', fields: [...filterTableData]}]}
                        _submitForm = {(e, form_type) => {e.preventDefault(); setFilterData({...tmpFilterData})}}
                        _is_download={false}
                        userRoleIds={props.userRoleIds}
                        selectOptions={{
                                    level_id: {value: 'id',
                                                label: 'label',
                                                data: [...dropdownOpt.level]},
                                    program_id: {value: 'id',
                                                label: 'label',
                                                data: [...dropdownOpt.program]},
                                    school_id:  {value: 'id',
                                                label: 'school_name',
                                                data: [...dropdownOpt.school]},
                                    branch_id:  {value: 'id',
                                                label: 'branch_name',
                                                data: [...dropdownOpt.branch]},
                                    is_completed:{value: 'id',
                                                 label: 'label',
                                                 data: yesNoOpp}
                                }}
                        _resetFilterForm = {(e) => {e.preventDefault(); setTmpFilterData({})}}
                    />
                </div>
                {/* {totalResult > 0 && !isLoading && (
                    <>
                    {isFilter === 1 && totalStudent > 0 && (
                        <p className="float-start m-2">Based on Filter: <b>{Math.round(((totalResult*100)/totalStudent)* 100)/100}%</b> Students</p>
                    )}
                    <p className="float-end m-2">Total: <b>{totalResult}</b> {totalResult > 1 ? 'Students' : 'Student'}</p>
                    </>
                    )} */}
            </div>

            {props.userRoleIds.some(role => [2, 3, 5, 7].includes(role)) && (
                <div className="col-lg-12 text-end">
                    <div className="d-grid float-end">
                    <button className="btn btn-info mb-2 p-2" onClick={(e) => toggleModal(e, 'cohort_new', true)}>Create Cohort</button>
                    </div>
                </div>
            )}

            {/* Filter */}

            {/* Listing */}
            <InfiniteListWrapper
                dataLength={masterTableData.length}
                isLoading={isLoading}
                hasNextPage={hasNextPage}
                fetchNextPage={fetchNextPage}
                isFetchingNextPage={isFetchingNextPage}
                emptyMessage="No Record found!"
            >
                <div className="col-lg-12 grid-margin stretch-card">
                    
                    <div className="card p-4 pb-0">

                        <div className="row">
                            {isLoading ? (
                                <div className="col-12 ps-2 pe-2">
                                        <img
                                            alt="Loader"
                                            src={require("../../assets/images/Image-Loader.gif")}
                                        />
                                </div>
                            ) : (
                                masterTableData.length > 0 
                                ? (
                                    <>
                                        {masterTableData.map((row, index) => {
                                            return (
                                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 ps-2 pe-2 pb-4" key={index}>
                                                    <div className="card">
                                                        <div className="bg-inverse-primary border pe-0 ps-3 pt-0">
                                                            <p className="fs-5 fw-bold mt-2">{row.cohort_title}</p>
                                                            <div>
                                                                {/* Add/Update */}
                                                                <WrapTooltip title="Add/Update Students">
                                                                    <button
                                                                        onClick={(e) => toggleModal(e,
                                                                                            'cohort_edit',
                                                                                            true,
                                                                                            {cohort_master_id: row.id,
                                                                                            title: row.cohort_title
                                                                                            }
                                                                                        )}
                                                                        disabled={(row.is_completed === 1 || (row.current_session_number === 1 && row.is_ready_for_award === 1) || row.current_session_number > 1) ? true : false}
                                                                        className={`btn btn-sm ms-1 me-1 mb-2 ${(row.is_completed === 1 || (row.current_session_number === 1 && row.is_ready_for_award === 1) || row.current_session_number > 1) ? 'disabled btn-inverse-secondary' : 'btn-inverse-info'}`}
                                                                    ><i className="mdi mdi-account-group"></i></button>
                                                                </WrapTooltip>
                                                                {/* Nomination */}
                                                                <WrapTooltip title="Nominations & Attendance">
                                                                    <button
                                                                        onClick={(e) => toggleModal(e,
                                                                                            'nomination',
                                                                                            true,
                                                                                            {cohort_master_id: row.id,
                                                                                            title: row.cohort_title
                                                                                            }
                                                                                        )}
                                                                        disabled={row.is_completed === 1 ? true : false}
                                                                        className={`btn btn-sm ms-1 me-1 mb-2 ${row.is_completed === 1 ? 'disabled btn-inverse-secondary' : 'btn-twitter'}`}
                                                                    ><i className="mdi mdi-account-key"></i></button>
                                                                </WrapTooltip>
                                                                {/* Award */}
                                                                <WrapTooltip title="Awards & Chair Rating">
                                                                    <button
                                                                        onClick={(e) => toggleModal(e,
                                                                                            'award',
                                                                                            true,
                                                                                            {cohort_master_id: row.id,
                                                                                            title: row.cohort_title
                                                                                            }
                                                                                        )}
                                                                        disabled={(row.is_completed === 1 || row.is_ready_for_award === 0) ? true : false}
                                                                        className={`btn btn-sm ms-1 me-1 mb-2 ${(row.is_completed === 1 || row.is_ready_for_award === 0) ? 'disabled btn-inverse-secondary' : 'btn-gradient-info'}`}
                                                                    ><i className="mdi mdi-trophy-outline"></i></button>
                                                                </WrapTooltip>
                                                                {/* View */}
                                                                <WrapTooltip title="View Details">
                                                                    <button
                                                                        onClick={(e) => toggleModal(e,
                                                                                            'cohort_view',
                                                                                            true,
                                                                                            {cohort_master_id: row.id,
                                                                                            fetch_type: 'view',
                                                                                            title: row.cohort_title
                                                                                            }
                                                                                        )}
                                                                        disabled={row.current_session_number > 1 ? false : true}
                                                                        className={`btn btn-sm ms-1 me-1 mb-2 ${row.current_session_number < 2 ? 'disabled btn-inverse-secondary' : 'btn-behance'}`}
                                                                    ><i className="mdi mdi-eye"></i></button>
                                                                </WrapTooltip>
                                                                {/* Report */}
                                                                <WrapTooltip title="Download Report">
                                                                    <button
                                                                        onClick={(e) => fetchViewDownloadDetails(e,
                                                                                            'cohort_download',
                                                                                            {cohort_master_id: row.id,
                                                                                            fetch_type: 'download',
                                                                                            title: row.cohort_title
                                                                                            }
                                                                                        )}
                                                                        disabled={row.current_session_number > 1 ? false : true}
                                                                        className={`btn btn-sm ms-1 me-1 mb-2 ${row.current_session_number < 2 ? 'disabled btn-inverse-secondary' : 'btn-facebook'}`}
                                                                    ><i className="mdi mdi-download"></i></button>
                                                                </WrapTooltip>
                                                                {/* Editor */}
                                                                <WrapTooltip title="Add/Update Editor">
                                                                    <button
                                                                        onClick={(e) => toggleModal(e,
                                                                                            'editor_update',
                                                                                            true,
                                                                                            {cohort_master_id: row.id,
                                                                                            title: row.cohort_title
                                                                                            }
                                                                                        )}

                                                                        disabled={!canUserEdit(row)}
                                                                        className={`btn btn-sm ms-1 me-1 mb-2 ${canUserEdit(row) ? 'btn-gradient-dark' : 'disabled btn-inverse-secondary'}`}
                                                                    ><i className="mdi mdi-account-edit"></i></button>
                                                                </WrapTooltip>
                                                                {/* Log */}
                                                                {/* <WrapTooltip title="Activity Log">
                                                                    <button
                                                                        onClick={(e) => updateStatus(e,
                                                                                            'status_change',
                                                                                            {active_status_id: row.active_status_id,
                                                                                            id: row.id,
                                                                                            type: row.for_all,
                                                                                            session_id: row.session_id
                                                                                            }
                                                                                        )}
                                                                        className="btn btn-sm ms-1 me-1 mb-2 btn-dark"
                                                                    ><i className="mdi mdi-view-list"></i></button>
                                                                </WrapTooltip> */}
                                                            </div>
                                                            {row.is_completed === 1 ?
                                                            <p className="mt-2 mb-1 text-success fs-12"><i className="mdi mdi-check-circle"></i> <span>Completed</span></p>
                                                            :
                                                            <p className="mt-2 mb-1 fs-12"><i className="mdi mdi-progress-clock"></i> <span className="text-warning">In-Progress: <b>Council {councilSessionNum?.[row.id]}</b></span></p>}
                                                            <p className="m-2 mt-0 mb-0 text-end fs-12 fst-italic one-line">{row.program_name}</p>
                                                            <p className="m-2 mt-0 text-end fs-12 fst-italic one-line">({row.level_name})</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </>
                                )
                                : 
                                <div className="col-12 ps-2 pe-2">
                                    <div className="no-fellow text-center mt-4">
                                        {/* {emptyImage && <img src={emptyImage} alt="No Data" />} */}
                                        <p className="pt-4 head">{"No Record Found!"}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </InfiniteListWrapper>
        </div>

        {/* New/Update Cohort Creation */}
        {activeEditForm && (
            <ModalMaster
                isShow={modalToggle[activeEditForm]}
                _toggleModal={(e, state) => toggleModal(e, activeEditForm, state)}
                modKey={activeEditForm}
                formType={activeEditForm}
                data={cohortFieldValue[activeEditForm]}
                title={modalTitle[activeEditForm]}
                _errorData={{...errorData}}
                _isProcess={{...isProcess}}
                // _isBtnDisabled={{...isBtnDisabled}}
                _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(form_type, variable_type, input_type, field, value)}
                _submitForm={(e, form_type) => submitForm(e, form_type)}
                buttonText={modalToggle.cohort_new
                                ? {text: 'Create', text_process: 'Creating'}
                                : {text: 'Update', text_process: 'Updating'}
                            }
                _formData={[...cohortFieldData]}
                userRoleIds={props.userRoleIds}
                noticeWarnings={(activeEditForm === "cohort_new"
                                || activeEditForm === "cohort_edit"
                            ) ? noticeWarningsMsgs.cohort_new
                              : activeEditForm === "nomination"
                                ? noticeWarningsMsgs.nomination
                                : []
                            }
                selectOptions={
                                modalToggle.cohort_new || modalToggle.cohort_edit
                                ?
                                    {level_id: {value: 'id',
                                                label: 'label',
                                                data: [...dropdownOpt.level]},
                                    program_id: {value: 'id',
                                                label: 'label',
                                                data: [...dropdownOpt.program]},
                                    school_id:  {value: 'id',
                                                label: 'school_name',
                                                data: [...dropdownOpt.school]},
                                    branch_id:  {value: 'id',
                                                label: 'branch_name',
                                                data: [...dropdownOpt.branch]},
                                    student_ids: {value: 'id',
                                                label: 'full_name',
                                                data: [...dropdownOpt.student],
                                                max: 20,
                                                format: {req: true, key: 'full_name', subkey: 'user_email.email'}},
                                    editor_ids: {value: 'id',
                                                label: 'name',
                                                data: [...dropdownOpt.editor],
                                                max: 10,
                                                format: {req: true, key: 'name', subkey: 'user_email.email'}}}
                                : modalToggle.nomination
                                        ?
                                            {
                                                chair_id: {value: 'user_id',
                                                            label: 'full_name',
                                                            data: [...dropdownNomiAwardOpt.chair],
                                                            format: {req: true, key: 'full_name', subkey: 'user.user_email.email'}},
                                                challenger_ids:  {value: 'user_id',
                                                            label: 'full_name',
                                                            data: [...dropdownNomiAwardOpt.challenger],
                                                            format: {req: true, key: 'full_name', subkey: 'user.user_email.email'}},
                                                presenter:  {value: 'user_id',
                                                            label: 'full_name',
                                                            data: [...dropdownNomiAwardOpt.presenter],
                                                            format: {req: true, key: 'full_name', subkey: 'user.user_email.email'}},
                                                mentor:  {value: 'user_id',
                                                            label: 'full_name',
                                                            data: [...dropdownNomiAwardOpt.mentor],
                                                            format: {req: true, key: 'full_name', subkey: 'user.user_email.email'}},
                                                absentee_ids:  {value: 'user_id',
                                                            label: 'full_name',
                                                            data: [...dropdownNomiAwardOpt.absentee],
                                                            format: {req: true, key: 'full_name', subkey: 'user.user_email.email'}},
                                                member_ids:  {value: 'user_id',
                                                            label: 'full_name',
                                                            data: [...dropdownNomiAwardOpt.member],
                                                            format: {req: true, key: 'full_name', subkey: 'user.user_email.email'}},
                                            }
                                        : modalToggle.award
                                            ?
                                                {presenter:  {value: 'user_id',
                                                            label: 'full_name',
                                                            data: [...dropdownNomiAwardOpt.presenter],
                                                            format: {req: true, key: 'full_name', subkey: 'user.user_email.email'}},
                                                mentor:  {value: 'user_id',
                                                            label: 'full_name',
                                                            data: [...dropdownNomiAwardOpt.mentor],
                                                            format: {req: true, key: 'full_name', subkey: 'user.user_email.email'}},
                                                challenger:  {value: 'user_id',
                                                            label: 'full_name',
                                                            data: [...dropdownNomiAwardOpt.challenger],
                                                            format: {req: true, key: 'full_name', subkey: 'user.user_email.email'}}
                                                }
                                            :  modalToggle.editor_update
                                            ?
                                                {editor_ids: {value: 'id',
                                                label: 'full_name',
                                                data: [...dropdownOpt.editor],
                                                max: 10,
                                                format: {req: true, key: 'full_name', subkey: 'user_email.email'}}}
                                            : {}
                            }
            />
        )}

        {/* View Details */}
        {modalToggle.cohort_view && (
            <ModalWrapper
                data={detailedCohortData}
                isShow={modalToggle.cohort_view}
                _toggleModal={(e, state) => toggleModal(e, 'cohort_view', state)}
                loader={false}
                title={modalTitle.cohort_view}
                detail_type={"html"}
            />
        )}
        </>
    );
}

export default GloscoCohortList;